import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

// Page content wrapper. Header, footer, cursor and transitions live in _app so
// they persist across routes; each page only renders its own sections here.
// Sections mark their colour environment with data-scene (see scene-controller).
export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <main id='main' className='relative'>
            {children}
        </main>
    )
}
